import React from 'react';
import { useTranslation } from 'react-i18next';

export default function useCustomHtmlTranslation(token, interpolation_hash: {}) {
  const { t } = useTranslation();

  const ret = (token, interpolation_hash) => {
//style={{backgroundColor: 'green', color: 'white'}}
    if (t(token, interpolation_hash) != null) {
      return  <div dangerouslySetInnerHTML={{ __html: t(token, interpolation_hash) }}/>
    } else {
      return token
    }
  }

  return ret;
}



// WEBPACK FOOTER //
// ./src/hooks/useCustomHtmlTranslation.js